// The clock the Trust pages measure ages against ("2 h", "3 days", "today").
//
// The seed dates its rows from the Settings demo day and anchor time, once.
// The browser clock moves on, so ages read from it drift away from the screens
// the day after the seed. The server sends its demo "now" with the pipeline,
// the briefing and the record; this module keeps the difference between that
// and the browser clock, so the page reads the same as the seed at load and
// then keeps time like any clock. Without a server time it is the browser clock.

let offsetMs = 0
let synced = false

/** Take the server's demo "now" (ISO, with a zone). A missing or bad value is ignored. */
export function syncDemoClock(serverNow: string | null | undefined): void {
  if (!serverNow) return
  const server = Date.parse(serverNow)
  if (Number.isNaN(server)) return
  offsetMs = server - Date.now()
  synced = true
}

/** True once a server demo "now" has been taken; before that the clock is the browser's. */
export function isDemoClockSynced(): boolean {
  return synced
}

export function demoNowMs(): number {
  return Date.now() + offsetMs
}

export function demoNow(): Date {
  return new Date(demoNowMs())
}

/** For tests: back to the browser clock. */
export function resetDemoClock(): void {
  offsetMs = 0
  synced = false
}
